( ( { hooks: { addFilter: addFilterBe } }, { hooks: { addFilter: addFilterFe } } ) => {  // eslint-disable-line
  addFilterBe(
    'b3rg_single_post_template',
    'b3rg/single-post',
    ( defaultValue ) => {
      return defaultValue;
    }
  );
} )( wp, feWp ); // eslint-disable-line no-undef
